export const base64ToObjectURL = (base64String: string): string => {
  // 1. Split the data URL to get the content type and the raw base64 data
  const parts = base64String.split(';base64,');
  const contentType = parts[0].split(':')[1];
  const raw = window.atob(parts[1]); // Decode base64

  // 2. Convert raw string to a Uint8Array
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  // 3. Create a Blob and an Object URL
  const blob = new Blob([uInt8Array], { type: contentType });
  return URL.createObjectURL(blob);
};
